import React, { FC, useEffect, useState } from 'react';
import { Image, Text, Layer, Stage } from 'react-konva';
import useImage from 'use-image';

interface MissingModelProps {
  width?: number,
  height?: number
}

const MissingModel: FC<MissingModelProps> = ({
  width = 1000,
  height = 1000
}) => {
  const [image, imageStatus] = useImage(`https://imagedelivery.net/8VO3fVWhjd7OVEhtl_T8-g/a38ab7bf-0989-4c0a-465c-600af6e69200/w=${width}`);
  const [x, setX] = useState<number>(0);
  const [y, setY] = useState<number>(0);

  // Center Image on canvas
  useEffect(() => {
    if (imageStatus === 'loaded') {
      if (image !== undefined) {

        /* after the image is loaded, you can get it's dimensions */
        const imageWidth = image?.width;
        const imageHeight = image?.height;

        /* 
          calculate the offsets so the image is centered inside
          the canvas
        */
        const xOffset = (width - imageWidth) / 2;
        const yOffset = (height - imageHeight) / 2;
        setX(xOffset);
        setY(yOffset);
      }
    }
  }, [
    width,
    height,
    image,
    imageStatus,
    setX,
    setY
  ]);

  return (
    <Stage width={width} height={height}>
      <Layer>
        <Image
          image={image}
          x={x}
          y={y} />
        <Text text="Missing Image"
          width={width}
          height={height}
          align="center"
          fontSize={width > 300 ? 36 : 24}
          fill={"rgba(225,225,225)"}
          x={x}
          y={height / 2} />
      </Layer>
    </Stage>
  );
}

export default MissingModel;
